// src/routes/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth"; // Import custom hook for authentication

const PrivateRoute = ({ children }) => {
  const { user } = useAuth(); // Access the user from the auth context

  if (!user) {
    // Redirect to login page if the user is not authenticated
    return <Navigate to="/" />;
  }

  return children; // If the user is authenticated, render the children (protected route)
};

export default PrivateRoute;
